import apiHandler from "../core/apiHandler";

const adminCashMonitorApi = apiHandler("admin/cash-monitor");

export default adminCashMonitorApi;
